import { createContext } from "react";

const SideBarContext = createContext();

export default SideBarContext;
